// Los videos ya salidos, firmados para verlos en su tarjeta apenas llegan
// (ADR-2026-10-30-videos-cortos-con-el-agente). El plan guarda la RUTA en Storage (la URL firmada
// vence a la hora); acá se firma una vez cada ruta, como `useMiniaturas` hace con las fotos del
// Catálogo. Una ruta que falló se vuelve a pedir en el próximo cambio.
import { useEffect, useRef, useState } from 'react';
import { firmarGenerada } from '../../../../lib/videoGenerado';

export interface VideoFirmado {
  url: string;
  poster: string | null;
}

export function useVideosFirmados(rutas: readonly string[]): Map<string, VideoFirmado> {
  const [mapa, setMapa] = useState(() => new Map<string, VideoFirmado>());
  const pedidas = useRef(new Set<string>());
  const clave = rutas.join(',');
  useEffect(() => {
    const faltan = rutas.filter((r) => !pedidas.current.has(r));
    if (faltan.length === 0) return;
    for (const r of faltan) pedidas.current.add(r);
    void Promise.all(
      faltan.map(async (ruta) => {
        const [url, poster] = await Promise.all([
          firmarGenerada(ruta).catch(() => null),
          firmarGenerada(ruta.replace('/full/', '/opt/').replace(/\.mp4$/i, '.png')).catch(() => null),
        ]);
        return { ruta, url, poster };
      }),
    ).then((firmados) => {
      setMapa((prev) => {
        const m = new Map(prev);
        for (const f of firmados) {
          if (f.url) m.set(f.ruta, { url: f.url, poster: f.poster });
          else pedidas.current.delete(f.ruta);
        }
        return m;
      });
    });
    // `clave` resume `rutas`: con el array como dependencia el efecto correría en cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clave]);
  return mapa;
}
